// Mock data for PAM IMMO SERVICES - Based on Class Diagram

// Company Info
export const companyInfo = {
  name: "PAM IMMO SERVICES",
  slogan: "Votre maison notre passion",
  phone: "+221 78 335 26 26",
  phone2: "+221 78 335 28 28",
  whatsapp: "+221 78 335 26 26",
  email: "contact@pamimmo.sn",
  address: "APIX TIVAOUNE PEULH, Sénégal",
  description: "PAM IMMO SERVICES est une entreprise immobilière de référence au Sénégal, spécialisée dans la vente de terrains, la construction clé en main et la gérance immobilière. Notre expertise locale et notre engagement qualité font de nous votre partenaire de confiance pour tous vos projets immobiliers."
};

// Enums based on Class Diagram
export const RoleType = {
  ADMIN: 'ADMIN',
  AGENT: 'AGENT',
  PROPRIETAIRE: 'PROPRIETAIRE'
};

export const TypeBien = {
  TERRAIN: 'Terrain',
  VILLA: 'Villa',
  APPARTEMENT: 'Appartement',
  IMMEUBLE: 'Immeuble'
};

export const UsageBien = {
  HABITATION: 'Habitation',
  INVESTISSEMENT: 'Investissement',
  COMMERCIAL: 'Commercial',
  MIXTE: 'Mixte'
};

export const StatutBien = {
  DISPONIBLE: 'Disponible',
  RESERVE: 'Réservé',
  VENDU: 'Vendu',
  EN_COURS: 'En cours'
};

export const TypeDemande = {
  CONTACT: 'Contact',
  BIEN: 'Bien',
  SERVICE: 'Service'
};

export const StatutDemande = {
  NOUVEAU: 'Nouveau',
  TRAITE: 'Traité',
  CLOS: 'Clos'
};

// Classe: Utilisateur
export const users = [
  {
    idUtilisateur: 'user-1',
    nom: 'Diop',
    prenom: 'Amadou',
    email: 'amadou.diop@pamimmo.sn',
    telephone: '+221 77 123 45 67',
    motDePasse: 'hashed_password',
    role: RoleType.ADMIN,
    actif: true,
    dateCreation: '2020-01-15T10:00:00Z'
  },
  {
    idUtilisateur: 'user-2',
    nom: 'Sall',
    prenom: 'Fatou',
    email: 'fatou.sall@pamimmo.sn',
    telephone: '+221 77 234 56 78',
    motDePasse: 'hashed_password',
    role: RoleType.AGENT,
    actif: true,
    dateCreation: '2021-03-20T10:00:00Z'
  }
];

// Classe: Localisation
export const localisations = [
  {
    idLocalisation: 'loc-1',
    pays: 'Sénégal',
    ville: 'Dakar',
    zone: 'Almadies',
    adresseComplete: 'Almadies, Route de Ngor, Dakar, Sénégal'
  },
  {
    idLocalisation: 'loc-2',
    pays: 'Sénégal',
    ville: 'Dakar',
    zone: 'Ngor',
    adresseComplete: 'Ngor, Corniche Ouest, Dakar, Sénégal'
  },
  {
    idLocalisation: 'loc-3',
    pays: 'Sénégal',
    ville: 'Dakar',
    zone: 'Mermoz',
    adresseComplete: 'Mermoz, près VDN, Dakar, Sénégal'
  },
  {
    idLocalisation: 'loc-4',
    pays: 'Sénégal',
    ville: 'Mbour',
    zone: 'Saly',
    adresseComplete: 'Saly, Route de Saly Portudal, Mbour, Sénégal'
  },
  {
    idLocalisation: 'loc-5',
    pays: 'Sénégal',
    ville: 'Dakar',
    zone: 'Ouakam',
    adresseComplete: 'Ouakam, près Mosquée de la Divinité, Dakar, Sénégal'
  },
  {
    idLocalisation: 'loc-6',
    pays: 'Sénégal',
    ville: 'Dakar',
    zone: 'Point E',
    adresseComplete: 'Point E, près Pullman, Dakar, Sénégal'
  },
  {
    idLocalisation: 'loc-7',
    pays: 'Sénégal',
    ville: 'Rufisque',
    zone: 'Diamniadio',
    adresseComplete: 'Diamniadio, Pôle Urbain, Rufisque, Sénégal'
  },
  {
    idLocalisation: 'loc-8',
    pays: 'Sénégal',
    ville: 'Thiès',
    zone: 'Ngaparou',
    adresseComplete: 'Ngaparou, Petite Côte, Thiès, Sénégal'
  }
];

// Classe: ImageBien
const createImages = (baseUrls) => {
  return baseUrls.map((url, index) => ({
    idImage: `img-${Date.now()}-${index}`,
    urlImage: url,
    ordreAffichage: index + 1,
    dateAjout: new Date().toISOString()
  }));
};

// Classe: BienImmobilier - Villas
export const villas = [
  {
    idBien: 'villa-1',
    titre: 'Villa Moderne Almadies',
    description: 'Magnifique villa moderne située dans le quartier prisé des Almadies. Architecture contemporaine, finitions haut de gamme, piscine, jardin paysager. Idéale pour une famille ou un investissement de prestige.',
    detailedDescription: 'Cette villa d\'exception allie modernité et élégance dans un cadre privilégié. Les espaces de vie spacieux et lumineux s\'ouvrent sur un jardin tropical avec piscine. La cuisine américaine entièrement équipée, les suites parentales avec dressing et les prestations haut de gamme font de cette propriété un lieu de vie unique.',
    typeBien: TypeBien.VILLA,
    usage: UsageBien.HABITATION,
    surface: 450,
    prix: 350000000,
    prixSurDemande: false,
    idLocalisation: 'loc-1',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-01-15T10:00:00Z',
    actif: true,
    // Additional attributes
    chambres: 5,
    sallesDeBain: 4,
    parking: 2,
    anneConstruction: 2022,
    etage: 2,
    caracteristiques: ['Piscine', 'Jardin paysager', 'Garage 2 voitures', 'Climatisation', 'Cuisine équipée', 'Alarme', 'Portail électrique'],
    images: createImages([
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811',
      'https://images.unsplash.com/photo-1613977257365-aaae5a9817ff',
      'https://images.unsplash.com/photo-1613977257592-4871e5fcd7c4'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'villa-2',
    titre: 'Villa avec Piscine Saly',
    description: 'Villa de standing avec piscine à Saly, proche de la plage. Parfaite pour résidence secondaire ou location touristique. Grand espace de vie extérieur, vue dégagée.',
    detailedDescription: 'Située à quelques minutes des plages de Saly, cette villa offre un cadre de vie exceptionnel. Les larges baies vitrées inondent les pièces de lumière naturelle. La piscine entourée d\'une grande terrasse est idéale pour se détendre. Parfait pour location saisonnière avec fort potentiel de rentabilité.',
    typeBien: TypeBien.VILLA,
    usage: UsageBien.INVESTISSEMENT,
    surface: 320,
    prix: 180000000,
    prixSurDemande: false,
    idLocalisation: 'loc-4',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-02-01T10:00:00Z',
    actif: true,
    chambres: 4,
    sallesDeBain: 3,
    parking: 2,
    anneConstruction: 2021,
    etage: 1,
    caracteristiques: ['Piscine', 'Proche plage', 'Terrasse', 'Sécurité 24/7', 'Parking', 'Jardin', 'BBQ'],
    images: createImages([
      'https://images.unsplash.com/photo-1613977257365-aaae5a9817ff',
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811',
      'https://images.unsplash.com/photo-1627141234469-24711efb373c'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'villa-3',
    titre: 'Villa de Luxe Ngor',
    description: 'Villa d\'exception avec vue mer panoramique à Ngor. Architecture raffinée, matériaux nobles, piscine à débordement, jardin tropical. Le summum du luxe.',
    detailedDescription: 'Cette propriété d\'exception offre une vue imprenable sur l\'océan. Chaque détail a été pensé pour le confort ultime : home cinema, salle de sport, cave à vin. La piscine à débordement semble se fondre dans l\'horizon. Un havre de paix pour une vie de prestige.',
    typeBien: TypeBien.VILLA,
    usage: UsageBien.HABITATION,
    surface: 550,
    prix: 420000000,
    prixSurDemande: false,
    idLocalisation: 'loc-2',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-01-20T10:00:00Z',
    actif: true,
    chambres: 6,
    sallesDeBain: 5,
    parking: 3,
    anneConstruction: 2023,
    etage: 2,
    caracteristiques: ['Vue mer', 'Piscine débordement', 'Jardin tropical', 'Home cinema', 'Garage 3 voitures', 'Salle de sport', 'Cave à vin'],
    images: createImages([
      'https://images.unsplash.com/photo-1756435292384-1bf32eff7baf',
      'https://images.unsplash.com/photo-1613977257365-aaae5a9817ff',
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'villa-4',
    titre: 'Villa Neuve Niaga',
    description: 'Villa neuve dans le quartier résidentiel de Niaga. Construction de qualité, bon rapport qualité-prix, quartier calme et familial. Parfaite pour première acquisition.',
    detailedDescription: 'Idéale pour une première acquisition, cette villa neuve offre tout le confort moderne dans un quartier familial calme. Construction soignée avec des matériaux de qualité. Jardin avec espace pour piscine future. Proche des écoles et commerces.',
    typeBien: TypeBien.VILLA,
    usage: UsageBien.HABITATION,
    surface: 280,
    prix: 165000000,
    prixSurDemande: false,
    idLocalisation: 'loc-3',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-03-01T10:00:00Z',
    actif: true,
    chambres: 4,
    sallesDeBain: 3,
    parking: 2,
    anneConstruction: 2024,
    etage: 1,
    caracteristiques: ['Construction neuve', 'Jardin', 'Garage', 'Quartier calme', 'Titre foncier', 'Portail automatique'],
    images: createImages([
      'https://images.pexels.com/photos/8470806/pexels-photo-8470806.jpeg',
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811',
      'https://images.unsplash.com/photo-1627141234469-24711efb373c'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'villa-5',
    titre: 'Villa Contemporaine Ouakam',
    description: 'Villa contemporaine au design épuré dans le quartier recherché d\'Ouakam. Espaces lumineux, architecture moderne, jardin arboré. Proche de toutes commodités.',
    detailedDescription: 'Cette villa contemporaine séduit par son architecture épurée et ses volumes généreux. Les espaces de vie ouverts favorisent la convivialité. Le jardin arboré offre un espace de détente appréciable. Quartier prisé, proche des ambassades et des commerces internationaux.',
    typeBien: TypeBien.VILLA,
    usage: UsageBien.HABITATION,
    surface: 380,
    prix: 295000000,
    prixSurDemande: false,
    idLocalisation: 'loc-5',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-02-15T10:00:00Z',
    actif: true,
    chambres: 5,
    sallesDeBain: 4,
    parking: 2,
    anneConstruction: 2022,
    etage: 2,
    caracteristiques: ['Design moderne', 'Jardin arboré', 'Bureau', 'Buanderie', 'Cuisine équipée', 'Terrasse', 'Parking'],
    images: createImages([
      'https://images.unsplash.com/photo-1627141234469-24711efb373c',
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811',
      'https://images.unsplash.com/photo-1613977257592-4871e5fcd7c4'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'villa-6',
    titre: 'Villa Familiale Point E',
    description: 'Spacieuse villa familiale dans le quartier central de Point E. Idéale pour grande famille, proche des écoles internationales et commerces. Quartier sécurisé.',
    detailedDescription: 'Villa familiale parfaitement située au cœur de Dakar. Les nombreuses chambres et espaces communs conviennent parfaitement à une grande famille. Jardin avec aire de jeux. Proximité immédiate des meilleures écoles internationales et des centres commerciaux. Quartier très sécurisé et calme.',
    typeBien: TypeBien.VILLA,
    usage: UsageBien.HABITATION,
    surface: 350,
    prix: 240000000,
    prixSurDemande: false,
    idLocalisation: 'loc-6',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-01-25T10:00:00Z',
    actif: true,
    chambres: 5,
    sallesDeBain: 3,
    parking: 2,
    anneConstruction: 2020,
    etage: 2,
    caracteristiques: ['5 chambres', 'Grand jardin', 'Aire de jeux', 'Proximité écoles', 'Quartier sécurisé', 'Garage double'],
    images: createImages([
      'https://images.unsplash.com/photo-1613977257592-4871e5fcd7c4',
      'https://images.unsplash.com/photo-1756435292384-1bf32eff7baf',
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811'
    ]),
    agentResponsable: 'user-2'
  }
];

// Classe: BienImmobilier - Terrains
export const terrains = [
  {
    idBien: 'terrain-1',
    titre: 'Terrain Viabilisé Diamniadio',
    description: 'Terrain viabilisé dans la nouvelle ville de Diamniadio. Zone en plein développement, toutes commodités, titre foncier en règle. Idéal pour construction résidentielle ou commerciale.',
    detailedDescription: 'Situé dans le pôle urbain de Diamniadio en pleine expansion, ce terrain viabilisé bénéficie de tous les réseaux (eau, électricité, assainissement). Titre foncier délivré. Zone à fort potentiel de valorisation. Idéal pour projet résidentiel haut de gamme ou commercial. Accès direct aux grandes artères.',
    typeBien: TypeBien.TERRAIN,
    usage: UsageBien.COMMERCIAL,
    surface: 500,
    prix: 25000000,
    prixSurDemande: false,
    idLocalisation: 'loc-7',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-02-10T10:00:00Z',
    actif: true,
    chambres: null,
    sallesDeBain: null,
    parking: null,
    anneConstruction: null,
    etage: null,
    caracteristiques: ['Titre foncier', 'Viabilisé', 'Zone commerciale', 'Accès facile', 'Électricité', 'Eau courante'],
    images: createImages([
      'https://images.pexels.com/photos/7578906/pexels-photo-7578906.jpeg',
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef',
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'terrain-2',
    titre: 'Terrain d\'Angle Mbao',
    description: 'Terrain d\'angle bien situé à Mbao. Quartier résidentiel calme, proche des transports. Titre foncier disponible. Parfait pour construction maison individuelle.',
    detailedDescription: 'Beau terrain d\'angle offrant une excellente exposition. Quartier résidentiel en développement avec infrastructures existantes. Proche des écoles, commerces et transports en commun. Titre foncier sécurisé. Possibilité de construire R+2. Bon investissement pour résidence principale.',
    typeBien: TypeBien.TERRAIN,
    usage: UsageBien.HABITATION,
    surface: 400,
    prix: 18000000,
    prixSurDemande: false,
    idLocalisation: 'loc-3',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-02-20T10:00:00Z',
    actif: true,
    chambres: null,
    sallesDeBain: null,
    parking: null,
    anneConstruction: null,
    etage: null,
    caracteristiques: ['Terrain d\'angle', 'Titre foncier', 'Quartier calme', 'Proche transports', 'Zone résidentielle'],
    images: createImages([
      'https://images.pexels.com/photos/7578906/pexels-photo-7578906.jpeg',
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef',
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'terrain-3',
    titre: 'Terrain Bord de Mer Ngaparou',
    description: 'Terrain exceptionnel en bord de mer à Ngaparou. Vue imprenable sur l\'océan, accès direct à la plage. Idéal pour villa de luxe ou projet touristique. Opportunité rare.',
    detailedDescription: 'Terrain d\'exception situé en première ligne avec accès direct à la plage. Vue panoramique sur l\'océan Atlantique. Zone touristique prisée de la Petite Côte. Parfait pour villa de luxe, résidence secondaire ou projet hôtelier. Titre foncier sécurisé. Investissement premium avec fort potentiel de plus-value.',
    typeBien: TypeBien.TERRAIN,
    usage: UsageBien.INVESTISSEMENT,
    surface: 600,
    prix: 45000000,
    prixSurDemande: false,
    idLocalisation: 'loc-8',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-01-30T10:00:00Z',
    actif: true,
    chambres: null,
    sallesDeBain: null,
    parking: null,
    anneConstruction: null,
    etage: null,
    caracteristiques: ['Bord de mer', 'Accès plage', 'Vue océan', 'Zone touristique', 'Titre foncier', 'Grande superficie'],
    images: createImages([
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef',
      'https://images.pexels.com/photos/7578906/pexels-photo-7578906.jpeg',
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'terrain-4',
    titre: 'Terrain Lotissement Keur Massar',
    description: 'Terrain dans nouveau lotissement à Keur Massar. Zone en développement rapide, infrastructures modernes. Prix attractif, facilités de paiement disponibles.',
    detailedDescription: 'Terrain situé dans un lotissement moderne et bien structuré à Keur Massar. Toutes les voies sont tracées, réseaux en cours de viabilisation. Zone résidentielle en pleine expansion. Prix très attractif avec possibilité de paiement échelonné. Idéal pour premier investissement immobilier.',
    typeBien: TypeBien.TERRAIN,
    usage: UsageBien.HABITATION,
    surface: 350,
    prix: 15000000,
    prixSurDemande: false,
    idLocalisation: 'loc-7',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-03-05T10:00:00Z',
    actif: true,
    chambres: null,
    sallesDeBain: null,
    parking: null,
    anneConstruction: null,
    etage: null,
    caracteristiques: ['Lotissement moderne', 'Prix attractif', 'Facilités de paiement', 'Zone en développement', 'Titre foncier en cours'],
    images: createImages([
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23',
      'https://images.pexels.com/photos/7578906/pexels-photo-7578906.jpeg',
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'terrain-5',
    titre: 'Terrain Commercial Rufisque',
    description: 'Grand terrain à vocation commerciale sur axe passant de Rufisque. Excellente visibilité, idéal pour centre commercial, station-service ou entrepôt.',
    detailedDescription: 'Terrain stratégiquement situé sur un axe très fréquenté de Rufisque. Grande superficie permettant de multiples possibilités d\'aménagement : centre commercial, station-service, showroom, entrepôt. Excellente visibilité et accessibilité. Titre foncier en règle. Fort potentiel commercial et de rentabilité.',
    typeBien: TypeBien.TERRAIN,
    usage: UsageBien.COMMERCIAL,
    surface: 800,
    prix: 35000000,
    prixSurDemande: false,
    idLocalisation: 'loc-7',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-02-25T10:00:00Z',
    actif: true,
    chambres: null,
    sallesDeBain: null,
    parking: null,
    anneConstruction: null,
    etage: null,
    caracteristiques: ['Grande superficie', 'Axe passant', 'Zone commerciale', 'Titre foncier', 'Viabilisé', 'Fort potentiel'],
    images: createImages([
      'https://images.pexels.com/photos/7578906/pexels-photo-7578906.jpeg',
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23',
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'terrain-6',
    titre: 'Terrain Résidentiel Sébikotane',
    description: 'Terrain dans zone résidentielle calme de Sébikotane. Environnement verdoyant, air pur. Idéal pour construction maison familiale. Bon rapport qualité-prix.',
    detailedDescription: 'Situé dans un environnement calme et verdoyant de Sébikotane, ce terrain offre un cadre de vie agréable loin de l\'agitation urbaine. Zone résidentielle en développement avec des constructions de qualité. Proche de l\'aéroport Blaise Diagne. Parfait pour construire une résidence familiale dans un environnement sain.',
    typeBien: TypeBien.TERRAIN,
    usage: UsageBien.HABITATION,
    surface: 300,
    prix: 12000000,
    prixSurDemande: false,
    idLocalisation: 'loc-7',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-03-10T10:00:00Z',
    actif: true,
    chambres: null,
    sallesDeBain: null,
    parking: null,
    anneConstruction: null,
    etage: null,
    caracteristiques: ['Zone calme', 'Environnement verdoyant', 'Titre foncier', 'Proche aéroport', 'Prix abordable'],
    images: createImages([
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef',
      'https://images.unsplash.com/photo-1518709268805-4e9042af9f23',
      'https://images.pexels.com/photos/7578906/pexels-photo-7578906.jpeg'
    ]),
    agentResponsable: 'user-2'
  }
];

// Classe: BienImmobilier - Appartements
export const appartements = [
  {
    idBien: 'appart-1',
    titre: 'Appartement Standing Mermoz',
    description: 'Appartement de standing au 3ème étage, quartier prisé de Mermoz. Lumineux, avec balcon, dans résidence sécurisée. Proche de toutes commodités.',
    detailedDescription: 'Magnifique appartement de 120m² au 3ème étage d\'une résidence moderne et sécurisée. Salon spacieux avec balcon offrant une belle vue. Cuisine américaine équipée. 3 chambres dont une suite parentale. Finitions de qualité. Quartier résidentiel calme et recherché, proche des écoles, commerces et restaurants.',
    typeBien: TypeBien.APPARTEMENT,
    usage: UsageBien.HABITATION,
    surface: 120,
    prix: 85000000,
    prixSurDemande: false,
    idLocalisation: 'loc-3',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-02-05T10:00:00Z',
    actif: true,
    chambres: 3,
    sallesDeBain: 2,
    parking: 1,
    anneConstruction: 2021,
    etage: 3,
    caracteristiques: ['3ème étage', 'Balcon', 'Résidence sécurisée', 'Ascenseur', 'Parking', 'Cuisine équipée'],
    images: createImages([
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267',
      'https://images.unsplash.com/photo-1502672260066-6bc61a2632d4',
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'appart-2',
    titre: 'Duplex Moderne Almadies',
    description: 'Superbe duplex dans le quartier huppé des Almadies. Vue mer, terrasse, prestations haut de gamme. Résidence avec piscine et salle de sport.',
    detailedDescription: 'Duplex d\'exception de 150m² répartis sur 2 niveaux. Salon cathédrale très lumineux, grande terrasse avec vue mer. 4 chambres dont 2 suites. Résidence de standing avec piscine commune, salle de sport et gardiennage 24h/24. Finitions luxueuses : parquet, cuisine italienne, domotique. Quartier privilégié des Almadies.',
    typeBien: TypeBien.APPARTEMENT,
    usage: UsageBien.HABITATION,
    surface: 150,
    prix: 125000000,
    prixSurDemande: false,
    idLocalisation: 'loc-1',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-01-28T10:00:00Z',
    actif: true,
    chambres: 4,
    sallesDeBain: 3,
    parking: 2,
    anneConstruction: 2023,
    etage: 5,
    caracteristiques: ['Duplex', 'Vue mer', 'Terrasse', 'Piscine commune', 'Salle de sport', '2 parkings'],
    images: createImages([
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2',
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267',
      'https://images.unsplash.com/photo-1502672260066-6bc61a2632d4'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'appart-3',
    titre: 'Appartement Neuf Sicap Liberté',
    description: 'Appartement neuf 2 chambres à Sicap Liberté. Parfait pour jeune couple ou investissement locatif. Résidence moderne et sécurisée.',
    detailedDescription: 'Bel appartement neuf de 90m² dans une résidence moderne. Salon lumineux avec cuisine ouverte équipée. 2 chambres avec placards intégrés. Salle de bains moderne et WC séparé. Balcon. Résidence sécurisée avec gardien. Idéal pour jeune couple ou excellent investissement locatif dans un quartier central et animé.',
    typeBien: TypeBien.APPARTEMENT,
    usage: UsageBien.INVESTISSEMENT,
    surface: 90,
    prix: 65000000,
    prixSurDemande: false,
    idLocalisation: 'loc-3',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-03-01T10:00:00Z',
    actif: true,
    chambres: 2,
    sallesDeBain: 2,
    parking: 1,
    anneConstruction: 2024,
    etage: 2,
    caracteristiques: ['Neuf', '2 chambres', 'Balcon', 'Sécurisé', 'Quartier central', 'Investissement rentable'],
    images: createImages([
      'https://images.unsplash.com/photo-1502672260066-6bc61a2632d4',
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2',
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'appart-4',
    titre: 'Penthouse Luxueux Ngor',
    description: 'Penthouse exceptionnel avec vue panoramique sur l\'océan. Grande terrasse, jacuzzi, prestations ultra haut de gamme. Le luxe absolu.',
    detailedDescription: 'Penthouse d\'exception au dernier étage offrant une vue à 360° sur l\'océan et la presqu\'île de Ngor. 180m² + 100m² de terrasse avec jacuzzi. 4 suites avec dressing. Cuisine ouverte sur grand salon. Domotique complète, climatisation centrale. 2 parkings + cave. Résidence ultra-sécurisée avec conciergerie. Un bien d\'exception.',
    typeBien: TypeBien.APPARTEMENT,
    usage: UsageBien.HABITATION,
    surface: 180,
    prix: 195000000,
    prixSurDemande: false,
    idLocalisation: 'loc-2',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-01-22T10:00:00Z',
    actif: true,
    chambres: 4,
    sallesDeBain: 3,
    parking: 2,
    anneConstruction: 2023,
    etage: 8,
    caracteristiques: ['Penthouse', 'Vue panoramique', 'Jacuzzi', 'Grande terrasse', '4 suites', 'Domotique'],
    images: createImages([
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267',
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2',
      'https://images.unsplash.com/photo-1502672260066-6bc61a2632d4'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'appart-5',
    titre: 'F3 Fonctionnel Plateau',
    description: 'Appartement F3 bien agencé au cœur du Plateau. Idéal bureau ou habitation. Proche de tout, transports accessibles. Bon investissement.',
    detailedDescription: 'Appartement fonctionnel de 80m² idéalement situé au Plateau, centre des affaires de Dakar. Proche de tous les services, banques, administrations et commerces. 2 chambres, salon, cuisine, salle de bain. Parfait pour bureau professionnel ou habitation. Excellent potentiel locatif. Immeuble entretenu avec gardien.',
    typeBien: TypeBien.APPARTEMENT,
    usage: UsageBien.COMMERCIAL,
    surface: 80,
    prix: 55000000,
    prixSurDemande: false,
    idLocalisation: 'loc-3',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-02-18T10:00:00Z',
    actif: true,
    chambres: 2,
    sallesDeBain: 1,
    parking: 1,
    anneConstruction: 2019,
    etage: 4,
    caracteristiques: ['Centre-ville', 'Proche tout', 'Fonctionnel', 'Bon investissement', 'Transports', 'Parking'],
    images: createImages([
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2',
      'https://images.unsplash.com/photo-1502672260066-6bc61a2632d4',
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267'
    ]),
    agentResponsable: 'user-2'
  },
  {
    idBien: 'appart-6',
    titre: 'Appartement Familial Ouakam',
    description: 'Grand appartement familial à Ouakam. Espaces généreux, résidence avec espaces verts et aire de jeux. Quartier calme et sécurisé.',
    detailedDescription: 'Spacieux appartement de 130m² idéal pour une famille. Grand séjour lumineux, cuisine équipée semi-ouverte. 3 grandes chambres avec placards. 2 salles de bains. Grand balcon. Résidence calme avec espaces verts, aire de jeux pour enfants et parking sécurisé. Quartier résidentiel d\'Ouakam, proche écoles et commerces.',
    typeBien: TypeBien.APPARTEMENT,
    usage: UsageBien.HABITATION,
    surface: 130,
    prix: 95000000,
    prixSurDemande: false,
    idLocalisation: 'loc-5',
    statut: StatutBien.DISPONIBLE,
    datePublication: '2024-02-12T10:00:00Z',
    actif: true,
    chambres: 3,
    sallesDeBain: 2,
    parking: 2,
    anneConstruction: 2020,
    etage: 2,
    caracteristiques: ['3 chambres', 'Espaces généreux', 'Aire de jeux', 'Espaces verts', 'Quartier familial', '2 parkings'],
    images: createImages([
      'https://images.unsplash.com/photo-1502672260066-6bc61a2632d4',
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267',
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2'
    ]),
    agentResponsable: 'user-2'
  }
];

// Classe: BienImmobilier - Projets
export const projects = [
  {
    idBien: 'project-1',
    titre: 'Résidence Les Jardins de Diamaguène',
    description: 'Nouveau projet résidentiel à Diamaguène. Appartements F2 à F4 dans résidence moderne avec piscine, salle de sport et espaces verts. Livraison 2025.',
    detailedDescription: 'Les Jardins de Diamaguène est un projet ambitieux de 120 logements répartis en plusieurs bâtiments. Architecture moderne, espaces communs de qualité avec piscine, salle de sport, terrain de jeux pour enfants et commerces de proximité. Sécurité 24h/24, parking souterrain. Du F2 au F4, finitions soignées. Facilités de paiement disponibles. Livraison prévue T2 2025.',
    typeBien: TypeBien.IMMEUBLE,
    usage: UsageBien.HABITATION,
    surface: 70, // Min surface
    prix: 45000000, // À partir de
    prixSurDemande: true,
    idLocalisation: 'loc-3',
    statut: StatutBien.EN_COURS,
    datePublication: '2024-01-10T10:00:00Z',
    actif: true,
    chambres: 2, // Min chambres
    sallesDeBain: 1,
    parking: 1,
    anneConstruction: 2025,
    etage: '1-5',
    caracteristiques: ['Piscine', 'Salle de sport', 'Espaces verts', 'Sécurité 24/7', 'Commerces', 'Parking souterrain'],
    images: createImages([
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00',
      'https://images.unsplash.com/photo-1560448204-e1a9518d0739',
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914'
    ]),
    dateLivraison: 'T2 2025',
    nombreTotalUnites: 120,
    unitesDisponibles: 45,
    agentResponsable: 'user-1'
  },
  {
    idBien: 'project-2',
    titre: 'Cité Moderne de Keur Massar',
    description: 'Projet de logements sociaux standing à Keur Massar. Maisons et appartements accessibles, dans environnement sécurisé. Facilités de paiement. Livraison 2025.',
    detailedDescription: 'La Cité Moderne de Keur Massar propose des logements de standing à prix abordables. 200 unités mixtes : maisons individuelles et appartements. Cadre de vie moderne avec voies bitumées, éclairage public, espaces verts. Proche de toutes commodités. Facilités de paiement échelonné sur 5 ans. Titre foncier individuel pour chaque lot. Livraison progressive dès mi-2025.',
    typeBien: TypeBien.IMMEUBLE,
    usage: UsageBien.HABITATION,
    surface: 60,
    prix: 35000000,
    prixSurDemande: true,
    idLocalisation: 'loc-7',
    statut: StatutBien.EN_COURS,
    datePublication: '2024-01-18T10:00:00Z',
    actif: true,
    chambres: 2,
    sallesDeBain: 1,
    parking: 1,
    anneConstruction: 2025,
    etage: '0-2',
    caracteristiques: ['Prix accessibles', 'Facilités de paiement', 'Titre foncier', 'Infrastructures modernes', 'Voies bitumées'],
    images: createImages([
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00',
      'https://images.unsplash.com/photo-1560448204-e1a9518d0739'
    ]),
    dateLivraison: 'T2 2025',
    nombreTotalUnites: 200,
    unitesDisponibles: 120,
    agentResponsable: 'user-1'
  },
  {
    idBien: 'project-3',
    titre: 'Résidence Premium Almadies Bay',
    description: 'Résidence ultra-luxe avec vue mer aux Almadies. Appartements et penthouses haut de gamme, prestations 5 étoiles. Piscine à débordement, spa, conciergerie.',
    detailedDescription: 'Almadies Bay redéfinit le luxe résidentiel à Dakar. 45 appartements et penthouses d\'exception avec vue mer. Architecture signée, matériaux nobles, domotique intégrée. Services 5 étoiles : conciergerie, spa, piscine à débordement, salle de fitness, business center. Sécurité maximale. Parking souterrain avec bornes électriques. Le prestige absolu. Livraison T4 2025.',
    typeBien: TypeBien.IMMEUBLE,
    usage: UsageBien.HABITATION,
    surface: 120,
    prix: 150000000,
    prixSurDemande: true,
    idLocalisation: 'loc-1',
    statut: StatutBien.EN_COURS,
    datePublication: '2024-01-05T10:00:00Z',
    actif: true,
    chambres: 3,
    sallesDeBain: 2,
    parking: 2,
    anneConstruction: 2025,
    etage: '1-10',
    caracteristiques: ['Vue mer', 'Prestations 5 étoiles', 'Spa', 'Conciergerie', 'Piscine débordement', 'Domotique'],
    images: createImages([
      'https://images.unsplash.com/photo-1560448204-e1a9518d0739',
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00'
    ]),
    dateLivraison: 'T4 2025',
    nombreTotalUnites: 45,
    unitesDisponibles: 12,
    agentResponsable: 'user-1'
  },
  {
    idBien: 'project-4',
    titre: 'Lotissement Les Collines',
    description: 'Grand lotissement viabilisé à Bambilor. Terrains de 200 à 400m², titres fonciers individuels. Proche de l\'aéroport AIBD. Facilités de paiement.',
    detailedDescription: 'Les Collines est un vaste lotissement moderne de 500 parcelles viabilisées à Bambilor. Toutes les infrastructures : routes bitumées, électricité, eau courante, assainissement, éclairage public. Terrains de différentes tailles pour tous budgets. Titre foncier individuel délivré. Zone en plein développement, proche de l\'aéroport international Blaise Diagne. Paiement échelonné possible sur 24 mois.',
    typeBien: TypeBien.TERRAIN,
    usage: UsageBien.HABITATION,
    surface: 200,
    prix: 8000000,
    prixSurDemande: true,
    idLocalisation: 'loc-7',
    statut: StatutBien.EN_COURS,
    datePublication: '2024-02-01T10:00:00Z',
    actif: true,
    chambres: null,
    sallesDeBain: null,
    parking: null,
    anneConstruction: null,
    etage: null,
    caracteristiques: ['Viabilisé complet', 'Titres fonciers', 'Routes bitumées', 'Proche AIBD', 'Facilités paiement'],
    images: createImages([
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00',
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914',
      'https://images.unsplash.com/photo-1560448204-e1a9518d0739'
    ]),
    dateLivraison: 'Disponible maintenant',
    nombreTotalUnites: 500,
    unitesDisponibles: 280,
    agentResponsable: 'user-1'
  },
  {
    idBien: 'project-5',
    titre: 'Résidence Green Park',
    description: 'Résidence écologique à Sébikotane. Logements éco-responsables avec panneaux solaires, récupération d\'eau, espaces verts. Cadre de vie sain et moderne.',
    detailedDescription: 'Green Park est un projet innovant alliant confort moderne et respect de l\'environnement. 80 logements éco-conçus avec panneaux solaires, système de récupération d\'eau de pluie, isolation thermique optimale. Grands espaces verts, potager communautaire, aire de jeux écologiques. Construction avec matériaux durables. Un cadre de vie sain pour votre famille. Livraison T3 2025.',
    typeBien: TypeBien.IMMEUBLE,
    usage: UsageBien.HABITATION,
    surface: 80,
    prix: 55000000,
    prixSurDemande: true,
    idLocalisation: 'loc-7',
    statut: StatutBien.EN_COURS,
    datePublication: '2024-01-25T10:00:00Z',
    actif: true,
    chambres: 2,
    sallesDeBain: 1,
    parking: 1,
    anneConstruction: 2025,
    etage: '0-3',
    caracteristiques: ['Éco-responsable', 'Panneaux solaires', 'Espaces verts', 'Potager communautaire', 'Construction durable'],
    images: createImages([
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00',
      'https://images.unsplash.com/photo-1560448204-e1a9518d0739'
    ]),
    dateLivraison: 'T3 2025',
    nombreTotalUnites: 80,
    unitesDisponibles: 35,
    agentResponsable: 'user-1'
  },
  {
    idBien: 'project-6',
    titre: 'Centre Commercial Diamniadio Plaza',
    description: 'Projet de centre commercial moderne à Diamniadio. Locaux commerciaux de 50 à 500m² à vendre ou louer. Emplacement stratégique, fort potentiel.',
    detailedDescription: 'Diamniadio Plaza sera le nouveau hub commercial de la zone. Centre commercial moderne sur 3 niveaux avec 120 espaces commerciaux modulables. Hypermarché, boutiques, restaurants, cinéma, espaces de loisirs. Parking de 400 places. Emplacement stratégique en plein cœur du pôle urbain. Fort trafic garanti. Opportunité d\'investissement unique pour commerçants et investisseurs. Livraison T1 2026.',
    typeBien: TypeBien.IMMEUBLE,
    usage: UsageBien.COMMERCIAL,
    surface: 50,
    prix: null,
    prixSurDemande: true,
    idLocalisation: 'loc-7',
    statut: StatutBien.EN_COURS,
    datePublication: '2024-02-08T10:00:00Z',
    actif: true,
    chambres: null,
    sallesDeBain: null,
    parking: 400,
    anneConstruction: 2026,
    etage: '0-3',
    caracteristiques: ['Emplacement stratégique', '3 niveaux', '120 commerces', 'Parking 400 places', 'Zone forte affluence'],
    images: createImages([
      'https://images.unsplash.com/photo-1560448204-e1a9518d0739',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00',
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914'
    ]),
    dateLivraison: 'T1 2026',
    nombreTotalUnites: 120,
    unitesDisponibles: 95,
    agentResponsable: 'user-1'
  }
];

// Classe: ServiceImmobilier
export const services = [
  {
    idService: 'service-1',
    nomService: 'Vente de Terrains',
    description: 'Nous proposons une sélection variée de terrains viabilisés dans les meilleures zones du Sénégal. Que vous recherchiez un terrain résidentiel ou commercial, notre équipe vous accompagne dans le choix du terrain idéal pour votre projet.',
    imageIllustration: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef',
    actif: true,
    caracteristiques: [
      'Terrains viabilisés',
      'Documentation légale complète',
      'Zones résidentielles et commerciales',
      'Accompagnement personnalisé'
    ]
  },
  {
    idService: 'service-2',
    nomService: 'Vente de Biens Immobiliers',
    description: 'Découvrez notre portfolio de biens immobiliers soigneusement sélectionnés : villas modernes, appartements de standing, locaux commerciaux. Chaque bien est vérifié et proposé avec toutes les garanties juridiques.',
    imageIllustration: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811',
    actif: true,
    caracteristiques: [
      'Villas de luxe',
      'Appartements modernes',
      'Locaux commerciaux',
      'Sécurité juridique garantie'
    ]
  },
  {
    idService: 'service-3',
    nomService: 'Construction Clé en Main',
    description: 'De la conception architecturale à la remise des clés, nous gérons l\'intégralité de votre projet de construction. Notre équipe d\'experts assure un suivi rigoureux pour garantir qualité, délais et budget.',
    imageIllustration: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5',
    actif: true,
    caracteristiques: [
      'Conception architecturale',
      'Gestion complète du projet',
      'Respect des délais',
      'Garantie qualité'
    ]
  },
  {
    idService: 'service-4',
    nomService: 'Gérance Immobilière',
    description: 'Confiez-nous la gestion de vos biens immobiliers en toute sérénité. Nous nous occupons de la location, de l\'entretien, de la perception des loyers et de toutes les démarches administratives.',
    imageIllustration: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa',
    actif: true,
    caracteristiques: [
      'Gestion locative',
      'Entretien des biens',
      'Perception des loyers',
      'Suivi administratif complet'
    ]
  },
  {
    idService: 'service-5',
    nomService: 'Terrassement',
    description: 'Nos équipes spécialisées réalisent tous vos travaux de terrassement avec des équipements modernes. Nous préparons votre terrain pour accueillir votre projet de construction dans les meilleures conditions.',
    imageIllustration: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12',
    actif: true,
    caracteristiques: [
      'Équipements modernes',
      'Équipes qualifiées',
      'Préparation du terrain',
      'Respect des normes'
    ]
  },
  {
    idService: 'service-6',
    nomService: 'Lotissement',
    description: 'Nous développons des projets de lotissement de qualité avec toutes les infrastructures nécessaires : routes, électricité, eau, assainissement. Des espaces de vie modernes et sécurisés pour votre investissement.',
    imageIllustration: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab',
    actif: true,
    caracteristiques: [
      'Infrastructures complètes',
      'Zones sécurisées',
      'Documentation légale',
      'Projets clés en main'
    ]
  }
];

// Classe: DemandeClient
export const demandesClients = [
  {
    idDemande: 'demande-1',
    nomClient: 'Moussa Sarr',
    telephoneClient: '+221 77 345 67 89',
    emailClient: 'moussa.sarr@email.com',
    message: 'Bonjour, je suis intéressé par la Villa Moderne Almadies. Pouvez-vous me contacter ?',
    typeDemande: TypeDemande.BIEN,
    dateDemande: '2024-03-15T14:30:00Z',
    statut: StatutDemande.NOUVEAU,
    idBien: 'villa-1',
    idService: null,
    agentAssigne: null
  },
  {
    idDemande: 'demande-2',
    nomClient: 'Aminata Diallo',
    telephoneClient: '+221 77 456 78 90',
    emailClient: 'aminata.diallo@email.com',
    message: 'Je souhaiterais avoir des informations sur vos services de gérance immobilière.',
    typeDemande: TypeDemande.SERVICE,
    dateDemande: '2024-03-16T10:15:00Z',
    statut: StatutDemande.TRAITE,
    idBien: null,
    idService: 'service-4',
    agentAssigne: 'user-2'
  },
  {
    idDemande: 'demande-3',
    nomClient: 'Ibrahima Ndiaye',
    telephoneClient: '+221 77 567 89 01',
    emailClient: 'ibrahima.ndiaye@email.com',
    message: 'Bonjour, j\'aimerais avoir des renseignements sur vos offres de terrains à Diamniadio.',
    typeDemande: TypeDemande.CONTACT,
    dateDemande: '2024-03-17T16:45:00Z',
    statut: StatutDemande.NOUVEAU,
    idBien: null,
    idService: null,
    agentAssigne: null
  }
];

// Classe: ContenuSite
export const contenusSite = [
  {
    idContenu: 'contenu-1',
    typeContenu: 'À propos',
    titre: 'À propos de PAM IMMO SERVICES',
    texte: 'PAM IMMO SERVICES est une entreprise immobilière de référence au Sénégal, spécialisée dans la vente de terrains, la vente de biens immobiliers, la construction clé en main, la gérance immobilière, le terrassement et le lotissement. Forte de plusieurs années d\'expérience dans le secteur immobilier sénégalais, notre entreprise s\'est imposée comme un acteur majeur grâce à son expertise locale, son professionnalisme et son engagement sans faille envers la satisfaction de ses clients.',
    dateMiseAJour: '2024-01-10T10:00:00Z'
  },
  {
    idContenu: 'contenu-2',
    typeContenu: 'Vision',
    titre: 'Notre Vision',
    texte: 'Devenir la référence incontournable de l\'immobilier au Sénégal en offrant des services d\'excellence et en contribuant au développement d\'un secteur immobilier moderne, transparent et accessible à tous.',
    dateMiseAJour: '2024-01-10T10:00:00Z'
  },
  {
    idContenu: 'contenu-3',
    typeContenu: 'Valeurs',
    titre: 'Nos Valeurs',
    texte: 'Confiance, Excellence, Accompagnement et Passion sont les quatre piliers qui guident notre action au quotidien et font de PAM IMMO SERVICES un partenaire de confiance pour tous vos projets immobiliers.',
    dateMiseAJour: '2024-01-10T10:00:00Z'
  }
];

// Export all properties for backward compatibility
export const properties = [...villas, ...terrains, ...appartements, ...projects];

// Statistics
export const stats = [
  { label: 'Biens vendus', value: '500+' },
  { label: 'Clients satisfaits', value: '1000+' },
  { label: 'Projets réalisés', value: '200+' },
  { label: 'Années d\'expérience', value: '5+' }
];

// Testimonials
export const testimonials = [
  {
    id: 1,
    name: 'Fatou Diop',
    role: 'Cliente',
    content: 'Excellente expérience avec PAM IMMO SERVICES. Ils m\'ont accompagnée tout au long de l\'achat de ma villa. Professionnalisme et réactivité au rendez-vous !',
    rating: 5
  },
  {
    id: 2,
    name: 'Moussa Sarr',
    role: 'Investisseur',
    content: 'J\'ai confié la gérance de mes biens à PAM IMMO SERVICES et je suis très satisfait. Gestion transparente et efficace. Je recommande vivement !',
    rating: 5
  },
  {
    id: 3,
    name: 'Aminata Kane',
    role: 'Cliente',
    content: 'Construction de ma maison réalisée dans les délais avec une qualité irréprochable. Équipe sérieuse et à l\'écoute. Merci PAM IMMO SERVICES !',
    rating: 5
  }
];

// Helper Functions for Dashboard (Future use)
export const getPropertyByID = (idBien) => {
  return properties.find(p => p.idBien === idBien);
};

export const getPropertiesByAgent = (idAgent) => {
  return properties.filter(p => p.agentResponsable === idAgent);
};

export const getDemandesByStatut = (statut) => {
  return demandesClients.filter(d => d.statut === statut);
};

export const getDemandesByAgent = (idAgent) => {
  return demandesClients.filter(d => d.agentAssigne === idAgent);
};

export const getActiveServices = () => {
  return services.filter(s => s.actif);
};

export const getPropertiesByStatut = (statut) => {
  return properties.filter(p => p.statut === statut);
};

export const getPropertiesByLocalisation = (idLocalisation) => {
  return properties.filter(p => p.idLocalisation === idLocalisation);
};
